var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundLogoXbank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 759.2,
    height: 194.907,
    viewBox: "0 0 759.2 194.907",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_599",
    "data-name": "Ret\\xE2ngulo 599",
    width: 759.2,
    height: 194.907,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_734",
    "data-name": "Grupo 734",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_732",
    "data-name": "Grupo 732",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1530",
    "data-name": "Caminho 1530",
    d: "M70.992,6.161H155.37c33.428,0,50.95,19.14,50.95,45.828,0,17.79-8.357,31.54-22.914,38.819v.537c19.407,6.2,31,22.38,31,43.407,0,27.494-17.792,47.713-52.028,47.713H70.992ZM151.056,77.6c14.288,0,21.025-8.626,21.025-19.679,0-11.322-5.389-19.679-21.294-19.679H105.5V77.6Zm5.391,73.055c16.175,0,22.645-9.435,22.645-21.027,0-11.861-8.087-21.3-22.375-21.3H105.5v42.324Z",
    transform: "translate(102.988 8.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1531",
    "data-name": "Caminho 1531",
    d: "M131.69,93.77c0-42.326,29.653-71.44,71.977-71.44,41.784,0,70.9,28.306,70.9,71.168v65.51H245.182V132.859c-8.087,19.679-26.149,29.653-47.176,29.653-32.349,0-66.316-23.184-66.316-68.742m110.8-1.348c0-23.456-15.635-40.169-39.089-40.169s-39.358,16.714-39.358,40.169,15.9,40.167,39.358,40.167,39.089-16.716,39.089-40.167",
    transform: "translate(191.043 32.395)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1532",
    "data-name": "Caminho 1532",
    d: "M196.291,89.727c0-44.48,26.419-67.4,65.779-67.4s65.777,22.647,65.777,67.4v69.281h-32.08V89.727c0-25.34-13.479-37.474-33.7-37.474s-33.7,12.133-33.7,37.474v69.281H196.291Z",
    transform: "translate(284.759 32.395)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1533",
    "data-name": "Caminho 1533",
    d: "M257.428,0H289.51V116.46l52.835-58.231h40.976l-62.542,65.24L385.747,191.4H343.965L289.51,131.286V191.4H257.428Z",
    transform: "translate(373.451 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1534",
    "data-name": "Caminho 1534",
    d: "M109.374,6.12,0,182.526H18.544L127.916,6.12",
    transform: "translate(0 8.878)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1535",
    "data-name": "Caminho 1535",
    d: "M122.957,6.12,13.583,182.526H32.127L141.5,6.12",
    transform: "translate(19.704 8.878)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1536",
    "data-name": "Caminho 1536",
    d: "M161.2,182.525h-51.83L0,6.119H51.83Z",
    transform: "translate(0 8.877)",
    fill: "#30ddff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundLogoXbank);
export default __webpack_public_path__ + "static/media/backgroundLogoXbank.1d3c86c415beb56d35167a8d5a6a5ebb.svg";
export { ForwardRef as ReactComponent };